module.exports = __webpack_public_path__ + "static/img/step_3-button-selected.883f8969.png";